import {Component} from '@angular/core';

@Component({
  selector: 'redirect-node',
  templateUrl: './redirect-node.component.html'
})
export class RedirectNodeComponent {
    node
}
